import React, { useEffect, useState } from 'react'
import { ColumnProjectType } from '../general/general-component/columns-component/ColumnProjectType'
import { AbstructVar } from '../general/general-component/abstruct-component/AbstructVar'
import SectionTopOfTable from '../general/general-component/section-top-of-table/SectionTopOfTable'
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom'
import InnerLoader from '../general/inner-loader/InnerLoader'
import { VariableProjectType } from './VariableProjectType'
import AddProjectType from './AddProjectType'
import { deleteProjectType, loadProjectTypes } from '../../store/Actions/ActionProjectType'
import { AbstructLang } from '../general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../general/general-component/abstruct-component/DeleteComponent'
import Warning from '../general/general-component/warning-delete/Warning'
import EditProjectType from './EditProjectType'
import FilterProjectType from './FilterProjectType'
import Table2 from '../table/Table2'
import { UsePermissions, hasPermissions } from '../general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../general/general-component/check-permissions'
import CheckLazyLoader from '../general/general-component/check-lazy-loader'

const ProjectTypes = () => {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { projectTypes, loadingProjectTypes } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableProjectType()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [projectTypesArr, setProjectTypesArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    const { permissionss, loadingMainPermission } = UsePermissions();
    const project_types = hasPermissions([{ name: "project-types" }], permissionss)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedProjectTypesArr = [...projectTypesArr];
            const indexToDelete = updatedProjectTypesArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedProjectTypesArr.splice(indexToDelete, 1);
                setProjectTypesArr(updatedProjectTypesArr);
            }
        }
    }, [isDeleted, idDeleted, projectTypesArr]);
    useEffect(() => {
        if (projectTypes?.length >= 0) {
            setProjectTypesArr(projectTypes)
        }
    }, [projectTypes]);
    useEffect(() => {
        dispatch(loadProjectTypes())
    }, []);

    const handleDelete = (id) => {
        dispatch(deleteProjectType(id, setloadDel, setIsDeleted, setIdDeleted));
    }

    const openAddProjectType = e => {
        e.preventDefault()
        setOpen(true)
    }

    const { columns } = ColumnProjectType(translate, warning, handleEdit, langLocal)

    return (
        <CheckLazyLoader>
            <CheckPermissions array={project_types} loadingMainPermission={loadingMainPermission} >
                <main>
                    <FilterProjectType translate={translate} />
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >
                        <SectionTopOfTable langLocal={langLocal} title={translate('ProjectTypes')} titleBtn={translate('Add')} FunctionBtn={openAddProjectType} />
                        {
                            loadingProjectTypes == false ? (
                                <Table2 col={columns} roo={projectTypesArr} />
                            ) : <InnerLoader />
                        }
                    </div>
                </main>
            </CheckPermissions>
            {
                state.open && (
                    <AddProjectType open={state.open} setOpen={setOpen} />
                )
            }
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.openEdit && (
                    <EditProjectType arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </CheckLazyLoader>
    )
}

export default ProjectTypes
